import {
  IconDefinition,
  IconName,
  IconPrefix,
} from "@fortawesome/fontawesome-svg-core";

/**
 * Custom FontAwesome-compatible icon definition for Funkwhale
 * Multi-path duotone icon matching the official Funkwhale logo
 * Uses FontAwesome duotone system for proper blue arcs + dark whale fluke
 */
export const faFunkwhale: IconDefinition = {
  prefix: "fab" as IconPrefix,
  iconName: "funkwhale" as IconName,
  icon: [
    512,
    512,
    [],
    "",
    // Multi-path array for duotone support
    [
      "M138.7 135.3c12.6 6.5 26.1 7.7 38.3 14.8 7.9 4.7 13 9.7 17.8 17.4 7.7 11.6 7.3 26.1 7.3 26.1l1 16s6.1 16 19.7 16c14.4 0 19.7-16 19.7-16l1-16s-.4-14.4 7.3-26.1c4.9-7.7 9.7-13.2 17.8-17.4 12.2-7.1 25.7-8.3 38.3-14.8s24.7-14.8 33-26.3c8.3-11.6 12.2-27 7.7-40.5-23.9-1.2-51.5 1.6-72.5 13-29.4 15.6-47.2 10.1-52.5 33.4h-.4c-5.3-23.5-22.9-17.8-52.5-33.4-21.1-11.3-48.6-14.2-72.5-13-4.7 13.6-.6 28.8 7.7 40.5 8.8 11.7 21.2 20 33.8 26.3",
      "M223.2 284.9c35.9 0 65.1-29.2 65.1-65.1 0-1.8-1.6-3.4-3.4-3.4h-24.5c-1.8 0-3.4 1.6-3.4 3.4 0 18.4-15 33.6-33.6 33.6-18.4 0-33.6-15-33.6-33.6 0-1.8-1.6-3.4-3.4-3.4h-24.5c-1.8 0-3.4 1.6-3.4 3.4-.4 36.1 28.8 65.1 64.7 65.1 M223.2 346.3c69.5 0 126.3-56.7 126.3-126.3 0-1.8-1.6-3.4-3.4-3.4h-24.5c-1.8 0-3.4 1.6-3.4 3.4 0 52.5-42.6 95-95 95s-95-42.6-95-95c0-1.8-1.6-3.4-3.4-3.4h-24.1c-1.8 0-3.4 1.6-3.4 3.4-.8 69.5 55.9 126.3 125.9 126.3 M407.6 216.6H383c-1.8 0-3.4 1.6-3.4 3.4 0 86.3-70.5 156.6-156.6 156.6-86.3 0-156.6-70.1-156.6-156.6 0-1.8-1.6-3.4-3.4-3.4H38.7c-1.8 0-3.4 1.6-3.4 3.4 0 103.6 84.3 187.9 187.9 187.9S411 323.6 411 220c0-1.8-1.6-3.4-3.4-3.4",
    ],
  ],
};

export default faFunkwhale;
